/** The reset link WorkOS emails, and where a social sign-in that still needs its email code lands. */
export const resetPasswordPath = "/auth/reset-password";

export interface PendingSignIn {
  pendingAuthenticationToken: string;
  email: string;
}

let resetToken: string | null = null;
let pendingSignIn: PendingSignIn | null = null;

/**
 * Takes the one-time secrets some links carry (the password reset token, and a
 * pending social sign-in with its email address) out of the address bar before
 * monitoring, attribution, or analytics read the URL. Every tag on the page
 * records full URLs, and a reset token alone resets the password. The pages
 * that need them read them from here.
 */
export function captureUrlSecrets(): void {
  const url = new URL(window.location.href);
  let changed = false;
  const token = url.searchParams.get("token");
  if (url.pathname === resetPasswordPath && token) {
    resetToken = token;
    url.searchParams.delete("token");
    changed = true;
  }
  const fragment = new URLSearchParams(url.hash.slice(1));
  const pending = fragment.get("pending");
  if (fragment.get("auth") === "verify-email" && pending) {
    pendingSignIn = {pendingAuthenticationToken: pending, email: fragment.get("email") ?? ""};
    // The marker stays, so the sign-in page still knows to ask for the code.
    fragment.delete("pending");
    fragment.delete("email");
    url.hash = fragment.toString();
    changed = true;
  }
  if (changed) window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}

/** The reset token the landing URL carried, if it was the reset page. */
export function capturedResetToken(): string | null {
  return resetToken;
}

/** The social sign-in waiting for its email code, if the landing URL carried one. */
export function capturedPendingSignIn(): PendingSignIn | null {
  return pendingSignIn;
}
